module.exports = __webpack_public_path__ + "static/media/es-ct.18deb6be.svg";